export default __webpack_public_path__ + "static/media/icon_insu.efc2cb2e.svg";